import Entity from "@/services/westore/entities/entity";

export class IntegrationHandshake extends Entity {
  static handle(marketPlace, query) {
    return super.get(`/integrations/${marketPlace}/handshake${query}`);
  }
  
}
